import { useCallback, useContext, useEffect, useRef } from 'react'
import { ReloadCallback, ScreenWideReloadContext } from './ScreenWideReloadProvider'

export function useReloadListener(callback: ReloadCallback) {
  const callbackRef = useRef(callback)
  const { addReloadListener } = useContext(ScreenWideReloadContext)
  const callbackStable = useCallback(() => callbackRef.current(), [])

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])
  useEffect(() => addReloadListener(callbackStable), [addReloadListener, callbackStable])
}
